<template>
  <div>
    <nav>
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a
          @click="handleStep('ESTOQUE')"
          :class="['nav-link link-nav-resident', step == 'ESTOQUE' && 'active']"
          id="nav-estoque"
          data-toggle="tab"
          href="#estoque"
          role="tab"
          aria-controls="estoque"
          aria-selected="true"
          >ESTOQUE MEDICAMENTO</a
        >
        <a
          @click="handleStep('ESTOQUE_PRODUTO')"
          :class="['nav-link link-nav-resident', step == 'ESTOQUE_PRODUTO' && 'active']"
          id="nav-estoque-produto"
          data-toggle="tab"
          href="#estoque-produto"
          role="tab"
          aria-controls="estoque-produto"
          aria-selected="true"
          >ESTOQUE PRODUTO</a
        >
        <a
          @click="handleStep('DEVOLUCAO')"
          :class="[
            'nav-link link-nav-resident',
            step == 'DEVOLUCAO' && 'active',
          ]"
          id="nav-devolucao"
          data-toggle="tab"
          href="#devolucao"
          role="tab"
          aria-controls="devolucao"
          aria-selected="true"
          >DEVOLUÇÃO</a
        >
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div
        v-if="step == 'ESTOQUE'"
        :class="['tab-pane fade', step == 'ESTOQUE' && 'show active']"
        id="estoque"
        role="tabpanel"
        aria-labelledby="nav-estoque"
      >
        <StockView />
      </div>
      <div
        v-if="step == 'ESTOQUE_PRODUTO'"
        :class="['tab-pane fade', step == 'ESTOQUE_PRODUTO' && 'show active']"
        id="estoque-produto"
        role="tabpanel"
        aria-labelledby="nav-estoque-produto"
      >
        <StockProductView />
      </div>
      <div
        v-if="step == 'DEVOLUCAO'"
        :class="['tab-pane fade', step == 'DEVOLUCAO' && 'show active']"
        id="devolucao"
        role="tabpanel"
        aria-labelledby="nav-devolucao"
      >
        <Devolution :resident="resident" @handleToResident="handleToResident" />
      </div>
    </div>
  </div>
</template>

<script>
import StockView from "./Stock/View";
import StockProductView from "./Stock/Product";

import Devolution from "./Stock/Devolution/Medicines";

import routes from "../../routes";

export default {
  name: "Stock",

  components: {
    StockView,
    StockProductView,
    Devolution,
  },

  props: {
    resident: Object,
  },

  data() {
    return {
      step: "ESTOQUE",
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    handleStep(step) {
      let newNav;

      if (step == "ESTOQUE") {
        newNav = "stock";
      }

      if (step == "ESTOQUE_PRODUTO") {
        newNav = "stock-product";
      }

      if (step == "DEVOLUCAO") {
        newNav = "devolution";
      }

      let { tab, nav } = routes.history.current.query;

      if (nav != newNav) {
        routes.replace({ query: { tab, nav: newNav } });
      }

      this.step = step;
    },

    async retrieve() {
      const { nav } = routes.history.current.query;

      if (nav) {
        if (nav == "stock") {
          this.step = "ESTOQUE";
        }
        if (nav == "stock-product") {
          this.step = "ESTOQUE_PRODUTO";
        }
        if (nav == "devolution") {
          this.step = "DEVOLUCAO";
        }
      }
    },

    handleToResident(resident_id) {
      this.$emit("handleToResident", resident_id);
    },
  },
};
</script>